<template>
  <div>
    <p v-for="(paragraph, index) in cPragraphs" :key="index">{{ paragraph }}</p>
  </div>
</template>

<script>
export default {
  name: 'SimpleParagraphs',
  props: {
    paragraphs: {
      type: [Array, Function]
    }
  },
  computed: {
    cPragraphs() {
      if (Array.isArray(this.paragraphs)) {
        return this.paragraphs
      } else {
        return this.paragraphs()
      }
    }
  }
}
</script>
